const initialState = {
    itens: [
        {
            tipo: 'textocurto-cpf',
            pergunta: 'CPF',
            obrigatorio: true,
            id: 0
        },
        {
            tipo: 'textocurto',
            pergunta: 'Nome',
            obrigatorio: true,
            id: 1
        },
        {
            tipo: 'email',
            pergunta: 'Email',
            obrigatorio: true,
            id: 2
        }
    ],
    proximoIndexItens: 8,
    titulo: '',
    descricao: '',
    permissao: 'LIVRE',
    servicoBoleto: "",
    temCertificado: false,
    limiteDeInscritos: 0,
    valorBoleto: '0,00',
    dataLimiteBoleto: '',
    dataInicio: '',
    dataValidade: '',
    resubmissao: false,
    confirmarPorEmail: false,
    interno: false,
    evento: 0
};

const itensEndereco = [
    {
        tipo: 'textocurto-cep',
        pergunta: 'CEP',
        obrigatorio: true,
        id: 3
    },
    {
        tipo: 'textocurto',
        pergunta: 'Logradouro',
        obrigatorio: true,
        id: 4
    },
    {
        tipo: 'textocurto',
        pergunta: 'Complemento',
        obrigatorio: false,
        id: 5
    },
    {
        tipo: 'numero',
        pergunta: 'Número',
        obrigatorio: false,
        id: 6
    },
    {
        tipo: 'textocurto',
        pergunta: 'Bairro',
        obrigatorio: true,
        id: 7
    }
]

const itemEvento = {   
    tipo: 'select',
    pergunta: 'Realizar inscrição como:',
    obrigatorio: true,
    opcoes: [
        {
            id: 0,
            texto: 'Aluno',
            valor: 0
        },
        {
            id: 1,
            texto: 'Professor',
            valor: 0
        },
        {
            id: 2,
            texto: 'Externo',
            valor: 0
        }
    ]
}

export default function reduce(state = initialState, action = {}) {
    switch (action.type) {
        case 'ADD_ITEM':
            return addItem(state, action.payload);
        case 'DELETE_ITEM':
            return deleteItem(state, action.payload);
        case 'UPDATE_ITEM':
            return updateItem(state, action.payload);
        case 'UPDATE_TITULO':
            return updateTitulo(state, action.payload);
        case 'UPDATE_DESCRICAO':
            return updateDescricao(state, action.payload);
        case 'UPDATE_STATE':
            return updateState(state, action.payload);
        case 'RESET_STATE':
            return resetState(state);
        case 'UP_CAMPO':
            return upCampo(state, action.payload)
        case 'DOWN_CAMPO':
            return downCampo(state, action.payload)
        case 'UPDATE_PERMISSAO':
            return updatePermissao(state, action.payload)
        case 'UPDATE_DATA_VALIDADE':
            return updateDataValidade(state, action.payload)
        case 'UPDATE_DATA_INICIO':
            return updateDataInicio(state, action.payload)
        case 'UPDATE_TEM_CERTIFICADO':
            return updateTemCertificado(state, action.payload)
        case 'UPDATE_LIMITE_DE_INSCRITOS':
            return updateLimiteDeInscritos(state, action.payload)
        case 'UPDATE_VALOR_BOLETO':
            return updateValorBoleto(state, action.payload)
        case 'UPDATE_DATA_LIMITE_BOLETO':
            return updateDataLimiteBoleto(state, action.payload)
        case 'UPDATE_RESUBMISSAO':
            return updateResubmissao(state, action.payload)
        case 'UPDATE_SERVICO_BOLETO':
            return updateServicoBoleto(state, action.payload)
        case 'UPDATE_EVENTO':
            return updateEvento(state, action.payload)
        case 'UPDATE_CONFIRMAR_POR_EMAIL':
            return updateConfirmarPorEmail(state, action.payload)
        case 'UPDATE_INTERNO':
            return updateInterno(state, action.payload)
        case 'UPDATE_TEM_BOLETO':
            return updateTemBoleto(state, action.payload)
        default:
            return state;
    }
}

function addItem(state, item){
    let id = state.proximoIndexItens;
    return {
        ...state,
        proximoIndexItens: id + 1,
        itens : [
            ...state.itens,
            {...item, id: id}
        ]
    }
}

function deleteItem(state, id){
    return {...state, itens: state.itens.filter(item =>
        item.id !== id
    )}
}

function updateItem(state, item){
    return {...state, itens: state.itens.map(itemN =>
            itemN.id === item.id ?
            item :
            itemN
    )}
}

function updateTitulo(state, titulo){
    return {...state, titulo: titulo}
}

function updateDescricao(state, descricao){
    return {...state, descricao: descricao}
}

function updateState(state, newState){
    return newState
}

function resetState(state){
    return initialState
}

function upCampo(state, item){
    const posicao = state.itens.indexOf(item)
    
    if(posicao > 0){
        const corrente_item = state.itens[posicao]
        const item_anterior =  state.itens[posicao - 1]

        state.itens[posicao] = item_anterior
        state.itens[posicao - 1] = corrente_item

    }

    return { ...state}
}

function downCampo(state, item){
    const posicao = state.itens.indexOf(item)

    if(posicao < state.itens.length - 1){
        const corrente_item = state.itens[posicao]
        const proximo_item =  state.itens[posicao + 1]

        state.itens[posicao] = proximo_item
        state.itens[posicao + 1] = corrente_item

    }

    return { ...state}
}

function updatePermissao(state, permissao){
    return {...state, permissao: permissao}
}

function updateDataValidade(state, dataValidade){
    return {...state, dataValidade: dataValidade}
}

function updateDataInicio(state, dataInicio){
    return {...state, dataInicio: dataInicio}
}

function updateTemCertificado(state, temCertificado){
    return {...state, temCertificado: temCertificado}
}

function updateLimiteDeInscritos(state, limiteDeInscritos){
    return {...state, limiteDeInscritos: limiteDeInscritos}
}

function updateValorBoleto(state, valorBoleto){
    return {...state, valorBoleto: valorBoleto}
}


function updateTemBoleto(state, temBoleto) {
    let itensN = [];
    let itensInicio = state.itens.filter(item => item.id <= 2);
    let itensNovos = state.itens.filter(item => item.id >= 8);
    if(temBoleto){
        itensN = itensInicio.concat(itensEndereco, itensNovos);
    }else{
        itensN = itensInicio.concat(itensNovos);
    }
    return {...state, temBoleto: temBoleto, itens: itensN}
}

function updateDataLimiteBoleto(state, dataLimiteBoleto){
    return {...state, dataLimiteBoleto: dataLimiteBoleto}
}

function updateResubmissao(state, resubmissao){
    return {...state, resubmissao: resubmissao}
}

function updateServicoBoleto(state, servicoBoleto){
    return {...state, servicoBoleto: servicoBoleto}
}

function updateEvento(state, temEvento){
    
    if(temEvento){
        let id = state.proximoIndexItens;
        state.itens.splice(3, 0, {...itemEvento, id: id})
        return{...state, proximoIndexItens: state.proximoIndexItens+1, evento: id}
    }else{
        return{...state, itens: state.itens.filter(item => item.id !== state.evento), evento: 0}
    }
}


function updateConfirmarPorEmail(state, temEmail){
    return {...state, confirmarPorEmail: temEmail}
}

function updateInterno(state, ehInterno){
    return {...state, interno: ehInterno}
}


// WEBPACK FOOTER //
// ./src/view/formulario/actions/FormBuilderReducers.js